import { schema } from 'normalizr'
import { patientSchema } from '@/schema/patient'
import { workerSchema } from '@/schema/worker'
import { scheduleCommentSchema } from '@/schema/scheduleComment'

export const scheduleSchema = new schema.Entity('schedules', {
  patient: patientSchema,
  worker: workerSchema,
  performedWorker: workerSchema,
  comments: [scheduleCommentSchema]
})
